'use strict';

class IHeader {
  constructor() {
    this.searchPlacehoder = $('.search-placeholder');
    this.searchAssociate = $('.search-associate');
    this.searchWrap = $('#search-wrap');
    this.searchInput = $('.search-input');
    this.urlParams = '';
    if (window.location.search) {
      let searchStr = window.location.search.slice(1);
      // 删除 searchkey 参数
      searchStr = searchStr.replace(/searchkey=[^&]*/, '');
      // 去除开头可能存在的 & 符号
      searchStr = searchStr.replace(/^&+/, '');
      // 如果还有参数存在，添加 & 前缀
      this.urlParams = searchStr ? '&' + searchStr : '';
    }
    this.initSearchBar();
  }
  initSearchBar() {
    document.getElementById('search-bar');
    document.getElementById('search-wrap');
    const searchInput = document.getElementById('search-input');
    const searchButton = $('.search-button');
    this.searchInput.on('click', (e) => {
      this.showSeacrhComp();
      e.stopPropagation();
    });
    $('body').on('click', () => {
      this.searchWrap.hide();
      this.searchAssociate.hide();
    });
    this.getData();
    // this.initDom(mockData)
    searchButton.on('click', () => {
      this.search(searchInput.value);
    });
    // 某些时候输入时未去除placeholder的处理
    $('#search-input').on('keydown', () => {
      // 输入的时候不管输入什么先去除placeholder
      this.searchPlacehoder.hide();
    });
    $('#search-input').on('keyup', (e) => {
      // 输入的时候不管输入什么先去除placeholder
      this.searchPlacehoder.hide();
      // enter搜索
      if (parseInt(e.keyCode) === 13) {
        this.search(searchInput.value);
      } else {
        setTimeout(() => {
          this.showSeacrhComp();
        }, 0);
      }
    });
  }
  showSeacrhComp() {
    if(this.searchInput.val()) {
      this.searchPlacehoder.hide();
      this.searchAssociate.show();
      this.searchWrap.hide();
      this.associateWords(this.searchInput.val());
    } else {
      this.searchPlacehoder.show();
      this.searchWrap.show();
      this.searchAssociate.hide();
    }
  }
  search(text) {
    text = text.trim();
    if (text === '') {
      text = this.searchPlacehoder.text();
    }
    window.wulinClick && wulinClick('BK_SEARCH');
    location.href = `//ruanjian.2345.cc/searchnew.php?searchkey=${encodeURIComponent(text)}${this.urlParams}`;
  }
  getData() {
    $.ajax('//baoku-safe.2345.com/soft/default', {
      timeout: 3000,
      jsonpCallback: 'jsonp_callback' + new Date().getTime(),
      dataType: 'jsonp',
      success: (res) => {
        this.initHotwordInterval(res.data);
        this.initDom(res.data);
      }
    });
  }
  associateWords(word) {
    $.ajax('//baoku-safe.2345.com/soft/search', {
      data: {
        word
      },
      method: 'GET',
      timeout: 3000,
      jsonpCallback: "jsoncallback" + new Date().getTime(),
      dataType: 'jsonp',
      success: (res) => {
        this.renderAssociate(res.data, word);
      }
    });
  }
  renderAssociate(words, hit) {
    if(!words || !words.length) return
    this.searchAssociate.show();
    const list = words.map(word => {
      return `<li class="word"><a onclick="wulinClick('BK_SEARCH')" href="//ruanjian.2345.cc/searchnew.php?searchkey=${encodeURIComponent(word.uninstallname)}${this.urlParams}">${word.uninstallname.replace(hit, '<span class="hit">' + hit + '</span>')}</a></li>`
    });
    this.searchAssociate.html(list.join(''));
  }
  initHotwordInterval(data) {
    const hotword = data.placeholder;
    if(!hotword || !hotword.length) return
    let i = 0;
    this.setPlaceholder(hotword[i]);
    const inputText = this.searchInput.val();
    // 输入框没有词，显示占位
    if(!inputText) {
      this.searchPlacehoder.show();
    }
    setInterval(() => {
      i++;
      if (i > hotword.length) i = 0;
      this.setPlaceholder(hotword[i]);
    }, 4000);
  }
  setPlaceholder(val) {
    this.searchPlacehoder.text(val);
  }
  OpenUrlHeaderClick(url) {
    var nextUrl = url;
    if (nextUrl.indexOf('?') === -1) {
      nextUrl += '?' + this.urlParams.slice(1);
    } else {
      nextUrl += this.urlParams;
    }
    return nextUrl
  }
  initDom(data) {
    const softmgr_url = data.softmgr_url || 'https://download.2345.cn/pic/own/2345pic_100094_v11.4.0.10421.exe';
    $('.safe-download').attr('href', softmgr_url);
    if(data.pic && data.pic.length) {

      const hotPicArr = data.pic.map(item => {
        return `<li class="soft-item clearfix" title="${item.softname}">
          <img src="${item.softlogo}" alt="" attr-url="${item.detailurl}"  class="safe-icon">
          <div class="info">
            <a href="javascript:;" attr-url="${item.detailurl}" class="name line-cut">${item.softname}</a>
            <div class="point">9.7分</div>
            <div class="download-btn" attr-safeaddress="${item.safeurl}" attr-softid="${item.softid}">安全下载</div>
          </div>
        </li>`
      });
      $('.main-soft-list').html(hotPicArr.join(''));
      var _this = this;
      $('.main-soft-list').on('click', function (e) {
        let url = '';
        if ($(e.target).hasClass('download-btn')) {
          url = $(e.target).attr('attr-safeaddress');
          let softid = $(e.target).attr('attr-softid');
          window.wulinClick && wulinClick(`BK_D_${softid}`);
          if (chrome.common2345 && chrome.common2345.invokeSoftwareManager) return chrome.common2345.invokeSoftwareManager(softid, url)
        } else if ($(e.target).hasClass('safe-icon') || $(e.target).hasClass('line-cut')) {
          url = _this.OpenUrlHeaderClick($(e.target).attr('attr-url'));
        }
        location.href = url;

      });
    }
    if(data.word && data.word.length) {
      let hotWordHtmlArr = data.word.map(item =>`
        <li class="soft-item">
          <a onclick="wulinClick('BK_SEARCH')" href="//ruanjian.2345.cc/searchnew.php?searchkey=${encodeURIComponent(item)}${this.urlParams}">
            <span>${item}</span>
          </a>
        </li>
      `);
      $('.inline-soft-list').html(hotWordHtmlArr.join(''));
    }
  }
}

function introSlide() {
  $('.slide-up').on('click', function() {
    $(this).css('display', 'none');
    $('.slide-down').css('display', 'inline');
    $('.intro-txt').removeClass('three-line');
  });
  $('.slide-down').on('click', function() {
    $(this).css('display', 'none');
    $('.slide-up').css('display', 'inline');
    $('.intro-txt').addClass('three-line');
  });
  if($('.intro-txt').height() <= 66) {
    $('.slide-button').hide();
  }
}
function getDate() {
  const today = new Date();
  return `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
}


function Point() {
  this.todayStr = getDate();
  this.canPoint = true;
  this.softId = (location.pathname.match(/\d+(?=\.html)/) || ['mock_id'])[0];
  this.render();
  const self = this;

  // if (this.softId === '38102') {
  //   $('.download-tip-explore').show()
  // } else {
  //   $('.download-tip-other').show()
  // }

  // 注册事件
  $('.my-point').on('mousemove', function(e) {
    if (!self.canPoint) return
    const starWidth = $(this).find('.star-container').outerWidth();
    const starLeft = $(this).find('.star-container').offset().left - $(this).offset().left;
    const offsetX = e.pageX - $(this).offset().left;
    const precent = offsetX <= starLeft ? 0 : offsetX >= starLeft + starWidth ? 1 : (offsetX - starLeft) / starWidth;
    $(this).find('.star-contxt').css('width', (precent * 100).toFixed(1) + '%');
    $(this).find('.point').text((precent * 10).toFixed(1).replace(/\.0$/, ''));
  });

  $('.my-point').on('mouseleave', function(e) {
    self.render();
  });

  $('.my-point').on('click', function(e) {
    if (!self.canPoint) return
    const point = $(this).find('.point').text();
    localStorage.setItem(self.softId + '_Point', `${self.todayStr}?${point}`);
    $.ajax('//ruanjian.2345.cc/remark', {
      timeout: 3000,
      dataType: 'json',
      data: {
        sid: self.softId,
        point,
        _rdn: Date.now(),
      }
    });
    self.canPoint = false;
  });
}

Point.prototype.render = function() {
  // 当前分数
  const [localDate, localPoint] = (localStorage.getItem(this.softId + '_Point') || '').split('?');
  // 判断是否过期 没有过期且已经有分数，则不能再打分
  if (localDate === this.todayStr && localPoint) {
    this.canPoint = false;
    $('.my-point').find('.point').text(localPoint);
    $('.my-point').find('.star-contxt').css('width', (localPoint * 10).toFixed(0) + '%');
  } else {
    this.canPoint = true;
    $('.my-point').find('.point').text('');
  }
};

class Swiper {
  constructor() {
    this.$wrapper = $('.swiper-wrapper');
    this.$slides = $('.swiper-slide');
    this.$dots = $('.swiper-dot');
    this.$preview = $('.swiper-preview');
    this.$previewImg = $('#swiper-preview-img');
    this.$container = $('.swiper-container');

    this.index = Math.floor(this.$slides.length / 2);
    this.autoTimer = null;

    this.updateUI();
    this.initEvents();
    this.startAutoPlay();
  }

  initEvents() {
    $('.swiper-button-prev').on('click', () => this.switch('prev'));
    $('.swiper-button-next').on('click', () => this.switch('next'));

    this.$slides.each((i, el) => {
      $(el).on('click', () => {
        if (i === this.index) {
          this.$preview.show();
          this.$previewImg.attr('src', $(el).find('img').attr('src'));
        }
      });
    });

    $('.swiper-preview-close').on('click', () => this.$preview.hide());
    $('.swiper-preview-prev').on('click', () => this.switch('prev'));
    $('.swiper-preview-next').on('click', () => this.switch('next'));

    $(document).on('keydown', (e) => {
      if (e.code === 'Escape') this.$preview.hide();
    });

    this.$container
      .on('mouseenter', () => this.stopAutoPlay())
      .on('mouseleave', () => this.startAutoPlay());
  }

  switch(direction) {
    if (direction === 'next') {
      this.index = (this.index + 1) % this.$slides.length;
    } else if (direction === 'prev') {
      this.index = (this.index - 1 + this.$slides.length) % this.$slides.length;
    }
    this.updateUI();
  }

  updateUI() {
    const $activeSlide = this.$slides.eq(this.index);

    const containerCenter = this.$container.offset().left + this.$container.outerWidth() / 2;
    const slideCenter = $activeSlide.offset().left + $activeSlide.outerWidth() / 2;

    const currentTransform = this.getTranslateX(this.$wrapper[0]);
    const delta = slideCenter - containerCenter;

    const newTransform = currentTransform - delta;
    this.$wrapper.css('transform', `translateX(${newTransform}px)`);

    this.$slides.each((i, el) => {
      $(el).toggleClass('swiper-slide-active', i === this.index);
    });

    this.$dots.each((i, el) => {
      $(el).attr('class', i === this.index ? 'swiper-dot dot-active' : 'swiper-dot');
    });

    if (this.$preview.css('display') === 'block') {
      this.$previewImg.attr('src', $activeSlide.find('img').attr('src'));
    }
  }

  getTranslateX(el) {
    const style = window.getComputedStyle(el);
    const matrix = new DOMMatrixReadOnly(style.transform);
    return matrix.m41 || 0;
  }

  startAutoPlay() {
    this.autoTimer = setInterval(() => {
      this.switch('next');
    }, 3000);
  }

  stopAutoPlay() {
    if (this.autoTimer) {
      clearInterval(this.autoTimer);
      this.autoTimer = null;
    }
  }
}


new IHeader();
introSlide();
new Point();

$(window).on('load', function () {
  new Swiper();
});
